/*
|----------------------------------------------------------
|   Front End System Configurations:
|----------------------------------------------------------
|   All config variables for the entire front end system
|   including the pjax system are stored in this file.
|
*/

export default {

  /**
   * Sets the pjax wrapper ID
   */
  wrapperId: 'pjax-wrapper',

  /**
   * Sets the pjax wrapper container class
   *
   * All content within this container will be
   * replaced on every pjax page load.
   */
  containerClass: 'pjax-container',

  /**
   * Sets the class name we could could use to
   * disable pjax page loads on links.
   *
   * NOTE: This selector name "no-pajax" is a typo. The correct
   * selector name of "no-pjax" was added to "noPjaxItems" config
   * to avoid braking functionality
   */
  ignoreClassLink: 'no-pajax', // please use no-pjax instead

  /**
   *  Sets the ajax timeout value
   *
   * Use this to force the pjax process to quit after at a certain
   * time and remove the page loader.
   */
  timeout: 20000,

  /**
   * Sets the EventBrite container class name
   *
   * Use this to include the class name section that
   * will always be present in all EventBrite embed div container's id name,
   * except the event ID
   */
  eventbriteContainerId: 'eventbrite-widget-container-',

  /**
   * String List of jQuery element class selectors to disable pjax
   *
   * Use this to add classes of elements that should not
   * trigger pjax calls
   */
  noPjaxItems: '#wpadminbar a, .languages-selector a, .lang-item a, .no-pjax, .no-pjax a, .no-ajax a, .no-ajax, .elementor-image-gallery a[data-elementor-open-lightbox="yes"], .gdpr-open-popup-link',

  /**
   * When true it will output all console logs
   * from the pjax.js file
   */
  debug: process.env.NODE_ENV === 'production' ? false : true
  //debug: true

}
